'use client';

interface ThemeWrapperProps {
  children: React.ReactNode;
}

/**
 * Client boundary wrapper for tenant-specific page content.
 *
 * CSS custom property injection is handled server-side by `ThemeStyles` (a Server Component),
 * which emits a `<style id="tenant-theme-styles">` tag in the SSR HTML before this component
 * is hydrated. This component exists solely to provide the `'use client'` boundary required
 * by its children (e.g. `MonarchProviderWrapper`).
 *
 * @param children - The tenant page subtree to render.
 */
export function ThemeWrapper({ children }: ThemeWrapperProps) {
  return <>{children}</>;
}
